import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MaterialModule } from "src/app/app.materials";

export interface UploadResultData {
  successCount: number;
  notFound: string[];
}

@Component({
  selector: "app-upload-result-dialog",
  templateUrl: "./upload-result-dialog.component.html",
  styleUrls: ["./upload-result-dialog.component.scss"],
  standalone: true,
  imports: [MaterialModule],
})
export class UploadResultDialogComponent {
  successCount: number;
  notFound: string[];

  constructor(
    public dialogRef: MatDialogRef<UploadResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadResultData,
  ) {
    this.successCount = data.successCount;
    this.notFound = data.notFound || [];
  }

  onContinue(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    sessionStorage.removeItem("importedCompanies");
    this.dialogRef.close(false);
  }
}
